var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 28,
    height: 28,
    rx: 14,
    transform: "rotate(-180 28 28)",
    fill: "#00E88F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1086 18.5581C16.3527 18.8021 16.3527 19.1979 16.1086 19.4419C15.8645 19.686 15.4688 19.686 15.2247 19.4419L10.2247 14.4419C9.98064 14.1979 9.98064 13.8021 10.2247 13.5581L15.2247 8.55806C15.4688 8.31398 15.8645 8.31398 16.1086 8.55806C16.3527 8.80213 16.3527 9.19786 16.1086 9.44194L11.5505 14L16.1086 18.5581Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.3bf2199831c092b11af0ac32062ad8dc.svg";
export { ForwardRef as ReactComponent };